import React, { PureComponent, Fragment } from 'react'
import styled from 'styled-components'
import { ReusableButton, TextAreaAutosize } from 'gipsy-ui'
import { styles, translations } from 'gipsy-misc'

class ReviewInputLinkForm extends PureComponent {
  state = {
    reviewInputLink: ''
  }

  componentDidMount = () => {
    /* doesnt work without timeout, set focus on title after popup transition */
    this.timeout = setTimeout(() => {
      this.input.focus()
    }, 400)
  }

  onProvideLink = () => {
    if (!this.state.reviewInputLink) {
      return
    }

    if (this.props.onProvideLink) {
      this.props.onProvideLink(this.state.reviewInputLink)
    }
    this.setState({ reviewInputLink: '' })
  }

  onSkip = () => {
    if (this.props.onSkip) {
      this.props.onSkip()
    }
    this.setState({ reviewInputLink: '' })
  }

  onChange = data => {
    this.setState({ reviewInputLink: data.value })
  }

  render() {
    const { reviewInputLink } = this.state

    const provideLinkMessage = translations.task.reviewInputLink.popup.provideLink
    const skipMessage = translations.general.skip

    return (
      <Fragment>
        <StyledTextArea
          placeholder={translations.task.reviewInputLink.placeholder}
          paramName="reviewInputLink"
          value={reviewInputLink}
          onChange={this.onChange}
          onSubmit={this.onProvideLink}
          ref={ref => {
            this.input = ref
          }}
        />
        <Actions>
          <ReusableButton
            onClick={this.onSkip}
            fontWeight={500}
            backgroundColor={styles.colors.darkGrey}
            style={{ marginRight: 12 }}>
            {skipMessage}
          </ReusableButton>
          <ReusableButton
            onClick={this.onProvideLink}
            fontWeight={500}
            style={{ marginLeft: 12 }}
            backgroundColor={reviewInputLink ? styles.colors.primaryColor : styles.colors.lightGrey}
            color={reviewInputLink ? 'white' : styles.colors.darkGrey}>
            {provideLinkMessage}
          </ReusableButton>
        </Actions>
      </Fragment>
    )
  }
}

export default ReviewInputLinkForm

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const StyledTextArea = styled(TextAreaAutosize)`
  padding: 20px 0px;
`



// WEBPACK FOOTER //
// ./src/features/popup/components/reviewInputLinkForm/index.js